<!-- Ported from the Polaris kit: src/components/ui/marker/MarkerContent.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <span
    data-slot="marker-content"
    :class="
      cn(
        'group-data-[variant=separator]/marker:flex-none group-data-[variant=separator]/marker:text-center [&>a:hover]:text-polaris-foreground [&>a]:underline [&>a]:underline-offset-[3px] min-w-0 break-words',
        props.class
      )
    "
  >
    <slot />
  </span>
</template>
